

















import DemoFile from '../../classes/Main/DemoFile'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFile } from '@fortawesome/free-solid-svg-icons'

export default {
  components: {
    FontAwesomeIcon,
  },
  props: {
    file: {
      type: DemoFile,
      required: true,
    },
  },
  computed: {
    name () {
      if (this.$route.meta.hideFileExtensions) {
        return this.file.getFilenameWithoutExtension()
      }
      return this.file.getFilename()
    },
    faFile () {
      return faFile
    },
    isActive () {
      return this.$route.path === this.file.path
    },
  },
}
